// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from 'react';

const SvgSocialLinkedin24 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			fill="currentColor"
			d="M19.62 2H4.38A2.38 2.38 0 0 0 2 4.38v15.24A2.38 2.38 0 0 0 4.38 22h15.24A2.38 2.38 0 0 0 22 19.62V4.38A2.38 2.38 0 0 0 19.62 2ZM8.188 9.62v9.047H5.333V9.619H8.19ZM5.333 6.984c0-.666.571-1.177 1.428-1.177s1.395.51 1.428 1.177c0 .666-.533 1.204-1.428 1.204-.857 0-1.428-.538-1.428-1.204Zm13.334 11.682H15.81v-4.762c0-.952-.478-1.905-1.67-1.925h-.037c-1.151 0-1.629.983-1.629 1.925v4.762H9.62V9.619h2.856v1.22s.92-1.22 2.768-1.22c1.89 0 3.424 1.3 3.424 3.934v5.114Z"
		/>
	</svg>
);
export default SvgSocialLinkedin24;
